import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "invoice-creator",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const InvoiceCreator = require("./containers").default;
          cb(null, InvoiceCreator);
        },
        "invoiceCreator"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/InvoiceCreator/index.js